const removeObjectKey = (obj, prop) =>
    Object.keys(obj).reduce((acc, key) => {
        if (key !== prop) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});

export default removeObjectKey;
